"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputWrap = void 0;

var _react = _interopRequireWildcard(require("react"));

var _translation_utils = require("../../translation_utils");

var _jsxRuntime = require("react/jsx-runtime");

const _excluded = ["id", "name", "children", "inline", "styles", "label"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Wrap = _ref => {
  let {
    id,
    name,
    children,
    inline,
    styles,
    label
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (inline) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles.inlineWrap,
      children: children
    }, name);
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
      className: styles.inputBlockWrap
    }, rest), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
        htmlFor: id,
        className: styles.label,
        children: label
      }, "label"), children]
    }), name);
  }
};

let InputWrap = (props, ref) => {
  const {
    id,
    name,
    formHook,
    children,
    schemaTypeName,
    styles,
    labelOverride,
    inline,
    addWrapperProps,
    helperText = '',
    errorText = ''
  } = props;
  const label = typeof labelOverride != 'undefined' ? labelOverride : (0, _translation_utils.trField)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrap, _objectSpread(_objectSpread({
    id: id,
    name: name,
    inline: inline,
    styles: styles,
    label: label
  }, addWrapperProps), {}, {
    children: [children, helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles.helper,
      children: helperText
    }), errorText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles.error,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles.errorMessage,
        children: errorText
      })
    })]
  }));
};

exports.InputWrap = InputWrap;
exports.InputWrap = InputWrap = /*#__PURE__*/(0, _react.forwardRef)(InputWrap);